<template>
<div>
  <div class="container">
    <form action="" class="form-horizontal">
      <div class="form-group label">
        <vs-input label="Nombre De Usuario" type="text" class="inputx" v-model="UserPost.username" /><br>
        <vs-input label="Email" type="text" class="inputx" v-model="UserPost.email" /><br>
        <vs-input label="Contraseña" type="text" class="inputx" v-model="UserPost.password"/><br>
        <vs-select placeholder="autocomplete" autocomplete label="Rol" v-model="role">
        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="item,index in roles"/>
        </vs-select><br>
        <vs-button class="bx bxs-paint-roll ml-3" @click="postUser()" color="darkgreen" type="border" icon="add">Crear</vs-button>
      </div>
    </form>
  </div>
  <br><br>
  <vs-alert class="ps_alert" color="danger" v-if="show">
        {{msg}}
  </vs-alert>
  <vs-alert class="ps_alert" color="success" v-if="show1">
        {{msg}}
  </vs-alert>
</div>
</template>
<script>
import axios from 'axios'
export default {
    name: "userAdd",
    props:{
    },
    components: {
},
    data:()=>({
    msg: '',
    show: false,
    show1: false,
    role: String,
    roles: Array,
    UserPost: {
        "username" : "",
        "email" : "",
        "password" : "",
        "role_id" : "",
    },
    error_msg: ''
  }),
  methods: {
    scrollInto(elementId) {
      const section = document.querySelector(`#${elementId}`);
      section.scrollIntoView({
        behavior: 'smooth'
      });
    },
    getRoles(){
      const url_api = this.$store.state.url_api
      axios.get(url_api + 'api/roleList').then(response => {
      this.roles = response.data
      this.role = response.data[0].id
      })
      .catch((error) => {
        this.msg = error.response.data
      })
    },
    postUser(){
      const url_api = this.$store.state.url_api
      this.UserPost.role_id = this.role
      axios.post(url_api + 'api/register/user', this.UserPost).then(response => {
        if (response.data == 'isOk'){
          this.show = false
          this.show1 = true
          this.msg = 'Successfully created'
        }
        else{
          this.show = true
          this.show1 = false
          this.msg = response.data
        }
      })
      .catch((error) => {
        this.show = true
        this.show1 = false
        this.msg = error.response.data
      })
    },
  },
  mounted(){
  this.getRoles()
  }
}
</script>
<style>
.ps_alert{
  margin-top: 1em;
}
  .label{
    text-align: left;
  }
.vs-select--label{
  color: #000000B3;
}
.vs-select--item{
  color: darkgreen;
}

element.style {
    font-weight: bold;
}
.vs-select-primary .vs-select--item.activex {
    background: rgb(23, 83, 65);
    color: white;
}
</style>